module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro-70541a40fd867544f590bc2e87b48f79.jpg";